import React from 'react';
// @ts-ignore
import styles from './index.m.less';
// @ts-ignore
import ImageRender from '@/components/GrtImage/ImageRender';

const noAuthImg = require('@/assets/images/no-auth.webp'),

 NoAuth = () => {
    return (
        <div className={styles['no-auth']}>
            <ImageRender className={styles['img']} src={noAuthImg}/>
            <div className={styles['text']}>您没有该组织的访问权限，如有疑问 请联系管理员</div>
        </div>
    );
};

export default NoAuth;
